export default {
  title: 'Datos bancarios',
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Información guardada correctamente.',
  },
};
